package com.partejar.app.feature.equipe.data.remote

import kotlinx.serialization.Serializable

@Serializable
data class EquipeProfileDto(val codigo: String, val nome: String)
@Serializable data class RegistroProfissionalEquipeDto(val id: Long, val categoriaProfissional: String? = null, val conselho: String, val numero: String, val uf: String, val ativo: Boolean = true)

@Serializable
data class EquipeMemberDto(
    val membroWorkspaceId: Long,
    val usuarioId: Long,
    val nome: String,
    val email: String,
    val perfil: EquipeProfileDto,
    val categoriaProfissional: String,
    val registroProfissional: RegistroProfissionalEquipeDto? = null,
    val ativo: Boolean
)

@Serializable
data class CriarConviteEquipeDto(
    val nome: String,
    val email: String,
    val perfilCodigo: String,
    val categoriaProfissional: String
)

@Serializable
data class AtualizarMembroEquipeDto(
    val perfilCodigo: String,
    val categoriaProfissional: String,
    val registroProfissionalId: Long? = null,
    val ativo: Boolean
)

@Serializable
data class ConviteEquipeDto(val conviteId: Long, val link: String, val expiraEm: String)
